// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2qrVV","modalForm":"UpgradeEpcsModal_modalForm__bkcre","modalFooter":"UpgradeEpcsModal_modalFooter__30jOO"};